import styled from 'styled-components';
import { ReactComponent as WarnCircleRed } from '@/assets/images/common/warnCircleRed.svg';

export const WARNING_NOTICE_HEIGHT = 83;

const WarningNotice = () => {
  return (
    <Wrapper>
      <WarnCircleRed style={{ minWidth: 32 }} />
      <WarningText>
        <div>비대면 처방 제한 의약품을 반드시 확인해주세요</div>
        <div>
          <span>사후피임약, 향정, 마약, 비아그라</span>등 비대면 처방 제한
          의약품을 처방하면 의원 및 약국 모두 행정처분 될 수 있습니다.
        </div>
      </WarningText>
    </Wrapper>
  );
};

export default WarningNotice;

const Wrapper = styled.div`
  position: absolute;
  top: -32px;
  left: -32px;
  width: 100vw;
  padding: 16px;
  height: ${WARNING_NOTICE_HEIGHT}px;
  display: flex;
  align-items: center;

  svg {
    margin-right: 16px;
  }
  ${({ theme }) => `
    background: ${theme.DF_COLOR.RED200};
  `};
`;

const WarningText = styled.div`
  ${({ theme }) => `
    background: ${theme.DF_COLOR.RED200};
    ${theme.DF_TYPOGRAPHY.UI17R};

    *:first-child {
      ${theme.DF_TYPOGRAPHY.UI17SB};
      margin-bottom: 3px;
    };
    *:last-child {
      span {
        color: ${theme.DF_COLOR.RED800};
      }
      color: ${theme.DF_COLOR.GRAY600};
    }
  `};
`;
